export enum eCalendarView {
  LIST_YEAR = 'listYear',
  LIST_MONTH = 'listMonth',
  LIST_WEEK = 'listWeek',
  LIST_DAY = 'listDay',
  DAY_GRID_MONTH = 'dayGridMonth',
  TIME_GRID_WEEK = 'timeGridWeek',
  TIME_GRID_DAY = 'timeGridDay',
  RESOURCE_TIME_GRID_DAY = 'resourceTimeGridDay',
  RESOURCE_TIMELINE_WEEK = 'resourceTimelineWeek',
}

export enum eAgendaTabs {
  EVENTS = 'EVENTS',
  CALENDAR = 'CALENDAR',
  TEAM = 'TEAM',
  CREATE_EVENT = 'CREATE_EVENT',
  TEMPLATES = 'TEMPLATES',
}

export enum eCalendarEventTypes {
  CALL = 'EVENT_TYPE_CALL',
  MEETING = 'EVENT_TYPE_MEETING',
  TASK = 'EVENT_TYPE_TASK',
}
